<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded main-height">
      <div class="flex justify-between">
        <!-- 削除ボタン -->
        <div v-if="isEdit" class="mr-1 mt-1 mb-3">
          <PrimaryButton text="削除" size="red-color text-white font-bold rounded px-3 py-2" class="" @click="deleteAll()" />
        </div>
      </div>
      <!-- 得意先 -->
      <div class="text-xs font-bold mt-auto text-gray-700">得意先</div>
      <WmsSuggestInput
        :name="'client'"
        :selectionItems="clientList"
        :displayField="['clientName1', 'clientName2']"
        :clearable="true"
        class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 mb-3"
        v-model="val.clientName"
        @selected="clientSelected($event)"
        @change="clientChange()"
      ></WmsSuggestInput>

      <div class="text-xs font-bold mt-auto text-gray-700">支店名</div>
      <WmsSuggestInput
        :name="'client2'"
        :selectionItems="clientList2"
        :displayField="['clientName2']"
        :clearable="true"
        class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 mb-3"
        v-model="val.clientName2"
        @selected="clientSelected2($event)"
      ></WmsSuggestInput>

      <div v-if="val.clientCode" class="text-xs flex mb-5 text-gray-600">
        <div class="font-bold mt-auto">得意先コード：</div>
        <div>{{ val.clientCode }}</div>
      </div>

      <!-- 物件名 -->
      <div class="text-xs font-bold mt-auto text-gray-700">物件名</div>
      <WmsSuggestInput
        :name="'site'"
        :selectionItems="siteList"
        :displayField="['nameSite1', 'nameSite2']"
        :clearable="true"
        class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 mb-3"
        v-model="val.siteName"
        @selected="siteSelected($event)"
        @change="siteChange()"
      ></WmsSuggestInput>

      <div v-if="val.siteCode" class="text-xs flex mb-5 text-gray-600">
        <div class="font-bold mt-auto">物件コード：</div>
        <div>{{ val.siteCode }}</div>
      </div>

      <!-- お客様担当者 -->
      <div class="text-xs font-bold mt-auto text-gray-700">お客様 ご担当者名</div>
      <input 
        type="text"
        class="cursor-text border-gray-300 rounded w-full py-1 focus:ring-indigo-500 focus:border-indigo-500 mb-3 text-sm"
        v-model="val.name"
      />

      <!-- メールアドレス -->
      <div class="text-xs font-bold mt-auto text-gray-700">メールアドレス</div>
      <input 
        type="email"
        class="cursor-text border-gray-300 rounded w-full py-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
        v-model="val.mail"
      />
      <div class="mt-3 mx-2 mb-1 min-w-500px">
          <PrimaryButton text="保存（メアド以外、自動で全角保存します）" size="normal w-full " @click="save()" />
      </div>
    </div>
    <div class="hidden">{{reload}}</div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'

const ROW = { clientName: '', clientName2: '', siteName: '', name: '様' }
export default {
  components: {
    WmsSuggestInput,
    Modal,
    PrimaryButton,
  },

  props: ['open', 'target'],

  data() {
    return {
      reload: 0,
      // 編集データ
      val: utils.clone(ROW),
      // 編集か否か
      isEdit: false,
      // ローディング
      loading: false,
      // 得意先リスト
      clientList: [],
      // 支店名リスト
      clientList2: [],
      // 物件リスト
      siteList: [],
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 編集対象データ取得
     */
    async getData() {
      this.loading = true
      // 編集対象データがある場合
      if (this.target) {
        this.isEdit = true
        const v = utils.clone(this.target)
        // エラーにならないように空文字にする
        if (!v.clientName) {
          v.clientName = ''
        }
        if (!v.clientName2) {
          v.clientName2 = ''
        }
        if (!v.siteName) {
          v.siteName = ''
        }
        if (!v.name) {
          v.name = '様'
        }
        this.val = v
        this.getSite()
      } else {
        this.isEdit = false
      }
      await this.getClient()
      this.loading = false
    },

    /**
     * 得意先リスト取得
     */
    async getClient() {
      const res = await backend.searchData('akbsTable/getClientList')
      if (res.data.data) {
        this.clientList = res.data.data
      } else {
        this.clientList = []
      }
    },

    /**
     * 物件リスト取得
     */
    async getSite() {
      if (this.val.clientCode) {
        const res = await backend.searchData('akbsTable/getSiteFromContractLadger', { clientCode: this.val.clientCode })
        if (res.data.data) {
          this.siteList = res.data.data
        } else {
          this.siteList = []
        }
      }
    },

    /**
     * データ削除
     */
    async deleteAll() {
      let resDlog = await dialogs.showConfirmDialog('削除', '削除してよろしいでしょうか？')
      if (resDlog != 'YES') {
        return
      }

      await backend.deleteData('mail/deleteData', this.val)
      logManager.recording(this, logManager.Loglevel.INFO, '見積書送付メールマスタ', '削除', `アドレス（${this.val.mail}）を削除しました。`)
      this.closed()
      this.$emit('close')
    },

    /**
     * 得意先選択イベント
     */
    async clientSelected(e) {
      this.loading = true
      await utils.wait(100)
      this.val.clientCode = e.clientCode
      this.val.clientName = e.clientName1
      if (e.clientName2) {
        this.val.clientName2 = e.clientName2
      } else {
        this.val.clientName2 = ''
      }
      this.clientList2 = this.clientList.filter((row) => {
        return row.clientName1 == e.clientName1
      })
      this.val.siteCode = ''
      this.val.siteName = ''
      await this.getSite()
      this.loading = false
      this.reload++
    },

    /**
     * 支店名選択イベント
     */
    async clientSelected2(e) {
      this.loading = true
      await utils.wait(100)
      this.val.clientCode = e.clientCode
      this.val.clientName = e.clientName1
      if (e.clientName2) {
        this.val.clientName2 = e.clientName2
      } else {
        this.val.clientName2 = ''
      }
      this.val.siteCode = ''
      this.val.siteName = ''
      await this.getSite()
      this.loading = false
      this.reload++
    },

    /**
     * 得意先名変更
     */
    clientChange() {
      if (!this.val.clientName) {
        this.val.clientName2 = ''
        this.val.clientCode = ''
        this.val.siteCode = ''
        this.val.siteName = ''
      }
      this.getSite()
      this.reload++
    },

    /**
     * 物件選択イベント
     */
    async siteSelected(e) {
      await utils.wait(100)
      this.val.siteCode = e.cdSite
      this.val.siteName = e.nameSite1
      if (e.nameSite2) {
        this.val.siteName2 = e.nameSite2
      }
      this.reload++
    },

    /**
     * 物件名変更
     */
    siteChange() {
      if (!this.val.siteName) {
        this.val.siteCode = ''
        this.reload++
      }
    },

    /**
     * 入力チェック
     */
    async validate() {
      if (!this.val.mail) {
        await dialogs.showErrorDialog('メールアドレス', 'メールアドレスを入力してください。')
        return false
      }

      let list = []
      const res = await backend.searchData('mail/getData', { type: 1 })
      if (res.data.data) {
        list = res.data.data
      }

      for (let i = 0; i < list.length; i++) {
        const o = list[i]
        if (o.mail == this.val.mail && (!o.id || (o.id != this.val.id))) {
          await dialogs.showErrorDialog('メールアドレス重複', '既に同じメールアドレスが登録されているため、保存できません。')
          return false
        }
      }

      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      if (!reg.test(this.val.mail)) {
          await dialogs.showErrorDialog('メールアドレス不正', `メールアドレスが不正です。`)
          return false
      }

      if (this.val.name == '様') {
        await dialogs.showErrorDialog('ご担当者名が「様」になっています', `ご担当者名を入力するか、削除してください。`)
        return false
      }

      if (this.val.name && this.val.name.indexOf('様') == -1) {
        const log = await dialogs.showConfirmDialog('ご担当者様に敬称がありませんがよろしいでしょうか？', '同じデータを使用しているところでご担当者様の名前をそのままメールに表示しているところもあります。「様」などの敬称はよろしいでしょうか？')
        if (log != 'YES') {
          return false
        }
      }
      return true
    },

    /**
     * 保存イベント
     */
    async save() {
      if (!await this.validate()) {
        return
      }
      const param = {
        type: 1,
        usesrId: this.$store.getters.user.id,
        userName: utils.deleteKana(this.$store.getters.user.user_name),
        ...this.val,
      }
      await backend.postData('mail/save', param)

      this.closed()
      this.$emit('close')
    },

    /**
     * 初期化
     */
    closed() {
      // 編集データ
      this.val = utils.clone(ROW),
      // 編集か否か
      this.isEdit = false
      // ローディング
      this.loading = false
      // 得意先リスト
      this.clientList = []
      // 物件リスト
      this.siteList = []
    }
  }
}
</script>
<style scoped>
.main-height {
  max-height: calc(100% - 200px);
}

.min-300 {
  min-width: 300px;
}

.red-color {
  background: #c94242;
}

@media screen and (max-width: 1200px) {
  .main {
      overflow: auto;
  }
}
</style>